import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function generateSessionId() {
  // Check if we already have a session ID in localStorage
  const existingSessionId = localStorage.getItem('vaai_session_id');
  if (existingSessionId) {
    return existingSessionId;
  }
  // Generate a new session ID and store it
  const newSessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  localStorage.setItem('vaai_session_id', newSessionId);
  return newSessionId;
}

export function formatPrice(price) {
  return price;
}

export function truncateText(text, maxLength = 100) {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}
